import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { ISearchBoxValue, ISelectInput } from '@portal/shared/ui/filter';
import isEmpty from 'lodash-es/isEmpty';
import { NgModel } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';

@Component({
    selector: 'portal-dropdown-search-filter',
    templateUrl: './dropdown-search-filter.component.html',
    styleUrls: ['./dropdown-search-filter.component.scss'],
    standalone: false
})
export class DropdownSearchFilterComponent implements OnInit, OnChanges, OnDestroy {
  @Input() entities: ISelectInput[];
  @Input() defaultEntityId: string;
  @Input() disabled = false;
  @Input() selectedSelector: Subject<string>;
  @Input() searchTerm: Subject<string>;
  @Output() searchTermChange = new EventEmitter<string>();
  @Output() searchEntityRemoved: EventEmitter<string> = new EventEmitter();
  @Output() searchUpdated: EventEmitter<ISearchBoxValue> = new EventEmitter();
  @Output() searchBoxInitComplete: EventEmitter<void> = new EventEmitter();
  @Output() inputValidationStateChange: EventEmitter<boolean> = new EventEmitter();

  @ViewChild('searchTermElem', { static: true }) searchTermElem: NgModel;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  _searchSelector = '';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  _searchTerm = '';
  searchSub: Subscription;
  selectorSub: Subscription;
  selectedItem: ISelectInput;
  pattern: RegExp;
  patternMessage: string;
  isOpen: boolean;
  label: string;
  constructor(private cd: ChangeDetectorRef, private elementRef: ElementRef) {
    this.isOpen = false;
    this.label = '';
  }

  ngOnInit(): void {
    let entity: ISelectInput;

    if (!isEmpty(this.entities)) {
      entity = this.getDefaultEntity();
      this._searchSelector = entity.id;
      this.selectedItem = entity;
      this.label = entity.text;
      this.updateEntityLocalData(entity);
    }

    this.searchSub = this.searchTerm?.pipe(debounceTime(10)).subscribe((val: string) => {
      this._searchTerm = val;
    });
    this.selectorSub = this.selectedSelector?.pipe(debounceTime(10)).subscribe((val: string) => {
      this._searchSelector = val;
      if (this._searchSelector && !isEmpty(this.entities)) {
        entity =
          this.entities.find((value: ISelectInput) => {
            return value.id === this._searchSelector;
          }) || entity;
        if (entity) {
          this.selectedItem = entity;
          this.label = entity.text;
          this.updateEntityLocalData(entity);
        }
      }
    });
    this.searchBoxInitComplete.emit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedItem) {
      this.label = this.selectedItem.text;
    }
  }

  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  setAutoFocusState(): void {
    this.elementRef?.nativeElement?.querySelector('.input').focus();
  }

  updateSelectedEntity(item: ISelectInput, event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    this.label = item.text;
    this.selectedItem = item;
    this.updateEntityLocalData(item);
    this.searchUpdated.emit(this.constructSearchOutput());
    this.isOpen = false;
    //this.onChange(item.id);
  }

  onSearchTermChange(value: string): void {
    this.searchTermChange.emit(value);
    this.searchUpdated.emit(this.constructSearchOutput());
  }

  isInputInvalid(): boolean {
    const isInvalid =
      this.pattern && this.searchTermElem.invalid && this.searchTermElem.errors.pattern;
    this.inputValidationStateChange.emit(!!isInvalid);
    return isInvalid;
  }

  ngOnDestroy(): void {
    this.searchSub?.unsubscribe();
    this.selectorSub?.unsubscribe();
  }

  private getDefaultEntity(): ISelectInput {
    return this.entities.find((entity) => entity.id === this.defaultEntityId) || this.entities[0];
  }

  private constructSearchOutput(): ISearchBoxValue {
    return {
      key: this.selectedItem.id,
      operator: '=',
      value: this._searchTerm,
    };
  }

  private updateEntityLocalData(entity: ISelectInput): void {
    this.pattern = entity?.pattern || null;
    this.patternMessage = entity?.patternMessage || null;
    this.cd.detectChanges();
  }
}
